import React from "react";
import { Grid, FormControlLabel, Checkbox } from "@material-ui/core";

function EmailColumnConfig({ values, setFieldValue, handleChange }) {
  const name = "default_email";

  return (
    <React.Fragment>
      {/* <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              name={`options.default_email`}
              checked={values.options.default_email}
              onChange={handleChange}
            />
          }
          label={"Default as Logged-in-user's email"}
        />
      </Grid> */}
      {/* {values.options[name] && (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                color="primary"
                name={`options.allow_free_text`}
                checked={values.options.allow_free_text}
                onChange={handleChange}
              />
            }
            label={"Allow to change email"}
          />
        </Grid> */}
      {/* )} */}
    </React.Fragment>
  );
}

export default EmailColumnConfig;
